import { Phone, CreditCard, ShieldCheck, FileText } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { COMPANY } from "@/lib/constants";

const INFO = [
  { icon: ShieldCheck, title: "Insurance Accepted", desc: "We are a preferred provider for most major insurance plans. If we can't take it, we'll help place it with a provider who can." },
  { icon: CreditCard, title: "Payment Options", desc: "We accept major insurance, Medicare/Medicaid where applicable, and private pay. Our team will verify your benefits before care begins." },
  { icon: FileText, title: "Transparent Billing", desc: "No surprises. We explain costs and coverage up front so you and your family can plan with confidence." },
];

export default function Payments() {
  useSEO({
    title: "Payments & Insurance | Esprit Home Healthcare",
    description: "Esprit Home Healthcare accepts most major insurance plans and private pay. Call (703) 998-7400 to verify your benefits.",
  });

  return (
    <div>
      <PageHeader
        overline="Payments"
        title="Insurance & Payment Options"
        subtitle="We make paying for care as easy as receiving it. Let our team verify your benefits and handle the arrangements."
      />

      <section className="container-page py-16 lg:py-24">
        <div className="grid md:grid-cols-3 gap-6">
          {INFO.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div className="h-full bg-card rounded-2xl border border-border p-8">
                <span className="grid place-items-center w-14 h-14 rounded-xl bg-primary/10 text-primary"><c.icon className="w-7 h-7" /></span>
                <h3 className="font-heading text-2xl text-primary mt-5">{c.title}</h3>
                <p className="text-muted-foreground mt-2 leading-relaxed">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="bg-primary text-primary-foreground rounded-[2rem] p-10 mt-12 text-center">
            <h2 className="font-heading text-4xl">Questions about coverage or billing?</h2>
            <p className="text-lg text-primary-foreground/80 mt-3 max-w-2xl mx-auto">
              Our friendly staff will help you understand your options and verify your benefits — at no cost.
            </p>
            <a href={COMPANY.phoneHref} className="inline-flex items-center gap-2 rounded-full bg-accent hover:bg-accent/90 text-accent-foreground h-16 px-8 text-xl font-bold mt-7 transition-colors">
              <Phone className="w-6 h-6" /> Call {COMPANY.phone}
            </a>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
